module.exports = __webpack_public_path__ + "a7ad987846f71f1149ff89471f575bfa.pdf";